<template lang="pug">
BriqPanel
  .flex.w-full.justify-between.multilanguage-picker-panel(:class="{'mb-S': showSecondColumn}")
    h2.m-0 Translations
    BriqButton(
      small
      variant="secondary"
      class="translation-button"
      @click="$emit('toggle')"
      data-test-id="translation-button"
      )
      .flex
        .translation-icon.mr-XXS
          BriqIcon(:name="`icon-input-${toggleTranslationIcon}-icon`") 
        .translation-text {{ toggleTranslationText }}
  BriqMultilanguagePicker(
    v-model="culture"
    :defaultCulture="defaultCulture"
    :cultures="cultures"
    :showSecondColumn="showSecondColumn"
    :disabled="disabled"
    )
</template>

<script>
import BriqMultilanguagePicker from '@v/components/BriqMultilanguagePicker.vue'

export default {
  name: 'BriqMultilanguagePickerPanel',
  components: { BriqMultilanguagePicker },
  props: {
    value: Object,
    defaultCulture: String,
    cultures: Array,
    showSecondColumn: Boolean,
    disabled: Boolean,
  },
  computed: {
    culture: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    toggleTranslationText() {
      const what = this.showSecondColumn ? 'Hide' : 'Show'
      return what + ' translations'
    },
    toggleTranslationIcon() {
      return this.showSecondColumn ? 'eye-crossed' : 'eye-open'
    },
  },
}
</script>
